'use strict';

const SectionPresenter = require('../presenters/section');

const BaseView = require('./base');

class SectionView extends BaseView {
  tagName() {
    return 'li';
  }

  initialize() {
    this.module = 'glive_booking_redesign';
    this.presenter = SectionPresenter;
    this.templateName = 'section';
    this.className = 'ls-cf';
  }

  events() {
    return { click: 'select' };
  }

  select(args, kill = false) {
    if (!kill) {
      $(args.toElement).trigger('click', true);
      this.trigger('select', this.model);
    }
  }
}

module.exports = SectionView;
